import { render, staticRenderFns } from "./ModalBuscaNcm.vue?vue&type=template&id=2605010a&scoped=true&"
import script from "./ModalBuscaNcm.vue?vue&type=script&lang=js&"
export * from "./ModalBuscaNcm.vue?vue&type=script&lang=js&"
import style0 from "./ModalBuscaNcm.vue?vue&type=style&index=0&id=2605010a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605010a",
  null
  
)

export default component.exports